// 必要なコンポーネントやライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー専用のレイアウトフレーム
import { Container, Box, Grid, Typography } from '@mui/material'; // Material-UIのコンポーネント（レイアウト用とUI要素）

/**
 * 利用規約テンプレートコンポーネント
 * 利用規約を表示するためのUI
 */
const UserTermsTemplate = () => {

    return (
        // ユーザー専用フレームで全体をラップ
        <UserFrame title=''> {/* タイトルは空の状態 */}
            {/* コンテンツの最大幅を`lg`（ラージサイズ）に設定 */}
            <Container maxWidth='lg'>
                {/* コンテンツを囲むボックス */}
                <Box 
                    sx={{
                        height: '640px', // ボックスの高さを640pxに設定
                        width: '100%', // 幅を100%に設定
                        overflow: 'scroll' // コンテンツが溢れた場合にスクロール可能にする
                    }}
                >
                    {/* グリッドレイアウトを使用してコンテンツを配置 */}
                    <Grid 
                        container 
                        direction="column" // コンテンツを縦方向に配置
                        alignItems="center" // コンテンツを中央揃え
                    >
                        {/* 利用規約のタイトル */}
                        <Grid item xs={2}> {/* 高さ2グリッド分を占有 */}
                            <Typography 
                                variant="h5" // テキストのスタイルを指定（見出し5）
                                sx={{ margin: '20px' }} // 外側に20pxの余白を設定
                            >
                                利用規約
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </UserFrame>
    );
}

// このコンポーネントをエクスポートして他のファイルで再利用可能にする
export default UserTermsTemplate;
